<template>
  <div>
    <jwplayer ref="jwplayer" :options="this.$manager.jwOptions"></jwplayer>
  </div>
</template>

<script>

  import PlayerMixin from '../mixins/PlayerMixin.vue'
  import axios from 'axios'

  export default {

    name: 'BobyConnectPlayer',

    mixins: [PlayerMixin],

    props: {
      videoCbinId: {
        required: true
      },
      api: {
        required: false,
        default () {
          return 'https://p-boby-connect-akamai.rtl2apps.de/rtl2/videocbin/' //1100039586
        }
      }
    },

    data () {
      return {
        videoData: null
      }
    },

    mounted () {
      this.loadVideoData()
    },

    methods: {

      /**
       * Metadaten werden von VIPO API geladen
       *
       * @author Thomas Petautschnig [tp@catdev.de]
       * @return {[type]} [description]
       */
      loadVideoData () {
        this.$l.log('loading videoCbinId', this.videoCbinId)

        axios.get( this.api + this.videoCbinId, {}).then((response) => {
          this.videoData = response.data.video[0]

          this.videoData.streamUrl = this.videoData.streamUrl.replace(/^http:\/\//i, 'https://');

          // videoId: 211,
          // formatId: 3373,
          // boNr: "070-018856-0022",
          // boId: 178163,
          // title: "Chethrin war die größte Lästerhexe!",
          // formatTitlel: "Love Island",
          // duration: 90,
          // description: "Mike hat nach Love Island noch so einiges über die anderen Islander und seine Zeit in der Villa zu erzählen. Der 25-Jährige verrät, welches Mädel er so richtig hot findet und mit wem er auf Love Island so gar nichts anfangen konnte.",
          // seoTitle: "Mike hat nach Love Island noch so einiges über die anderen Islander und seine Zeit in der Villa zu e",
          // seoDescription: "Mike hat nach Love Island noch so einiges über die anderen Islander und seine Zeit in der Villa zu e",
          // streamUrl: "http://trans01dach-vh.akamaihd.net/i/delivery/7b/e4/7be4bf19-e07d-4b82-a690-a9f5c989ddc8/01SZ2D0010333WVB_,65,3850,650,1000,2350,250,1350,k.mp4.csmil/master.m3u8",
          // image: "http://p-assets1.rtl2.de/4238199_01sz2d0010333wvb_video-love-island-interview-mike.png"


          this.$manager.addItemData({
            source: 'bobyconnect',
            id: this.videoCbinId,
            title: this.videoData.title,
            description: this.videoData.description,
            poster: this.videoData.image,
            format: this.videoData.formatTitle,
            formatId: this.videoData.formatId,
            duration: this.videoData.duration,
            adZone: this.videoData.marketingtheme
          })


          this.setupVideo()
        }).catch((error) => {
          this.$warn('BOBY CONNECT API Error', error)
          this.$events.fire('fatalError', {msg: 'Fehler beim laden der Videodaten :('})
        })
      },

      /**
       * JWPlayer Setup
       *
       * @author Thomas Petautschnig [tp@catdev.de]
       * @return {[type]} [description]
       */
      setupVideo () {

        var video = this.videoData;

        if(video.marketingtheme) {
            this.$videoAdSchedule.setup({
                duration: video.duration,
                streamurl: this.$helpers.streamToHttps(video.streamUrl),
                zone: 'rtl2_rtl2/'+video.marketingtheme
            })

            if(this.$settings.ads) {

                this.$videoAdSchedule.activate()

                // Settings übernehmen
                this.$l.log('adSchedule setup', this.$videoAdSchedule.adSchedule)
                this.$manager.addOptions('advertising', {
                    schedule: this.$videoAdSchedule.adSchedule
                })
            }
        }


        // Playliste übernehmen
        this.$manager.addPlaylist([{
          title: video.title,
          description: video.description,
          image: video.image,
          sources: [{
            file: this.$helpers.streamToHttps(video.streamUrl),
            type: 'hls'
          }]
        }])

        // Setup fertig
        this.$manager.finalizeSetup()
      }


    }

  }
</script>



// WEBPACK FOOTER //
// src/components/BobyConnect.vue